import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../Contexts/userContext";
import { categoriesURL, currenciesURL } from "../Hooks/URL";
import CreateCategory from "../Templates/Home/Categories/CreateCategory/CreateCategory";
import { useNavigate } from "react-router";
import useFetch from "../Hooks/useFetch";

function CreateCategoryPage() {
  const navigate = useNavigate();
  const { contextData, setContextData } = useContext(userContext);
  const [currencies, setCurrencies] = useState([]);

  const { data: currenciesData, loading: currenciesLoading } =
    useFetch(currenciesURL);

  useEffect(() => {
    if (!currenciesLoading && currenciesData) {
      setCurrencies(currenciesData.data || []);
    }
  }, [currenciesData, currenciesLoading]);

  useEffect(() => {
    setContextData({ ...contextData, page: "createCategory" });
  }, []);

  return (
    <CreateCategory
      navigate={navigate}
      categoriesURL={categoriesURL}
      currencies={currencies}
      currenciesLoading={currenciesLoading}
    />
  );
}

export default CreateCategoryPage;
